require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gruppo-di-ricerca-alberto-franchini.json") })
        }
      }, "path---gruppo-di-ricerca-alberto-franchini");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gruppo-di-ricerca-alberto-franchini!./.cache/json/gruppo-di-ricerca-alberto-franchini.json
// module id = 660
// module chunks = 231608221292675